module.exports = __webpack_public_path__ + "static/img/sg_btn1.f1582f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/hk/img/home/pc/role3/control/sg_btn1.png
// module id = Iw0F
// module chunks = 7